import React from 'react';
import { DisclosureButton, DisclosurePanel } from '@headlessui/react';
import Link from 'next/link';
import { WithTranslation } from 'next-i18next';
import { withTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getClassNameForMobile } from '../../nav-helpr';
import { Separator } from '@lb-classroom/ui';

interface Props extends WithTranslation {
  t: any;
  handleLogout: () => void;
  ticketCount: number;
}

const StudentHeaderMobile: React.FC<Props> = ({
  t,
  handleLogout,
  ticketCount,
}: Props) => {
  const { pathname: currentPath } = useRouter();
  return (
    <DisclosurePanel className="md:hidden">
      {({ close }) => (
        <div className="pt-2 pb-3 space-y-1">
          <div className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">
            {t('service.header.ticketCount', {
              count: ticketCount,
              smart_count: ticketCount,
            })}
          </div>
          <Separator className="my-2" />
          {/* Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-default hover:bg-gray-50 hover:border hover:text-gray-700" */}
          <DisclosureButton as={Link} href="/s/dashboard">
            <a
              className={getClassNameForMobile('/s/dashboard', currentPath)}
              onClick={() => close()}
            >
              {t('service.header.dashboard')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/s/booking-calendar">
            <a
              className={getClassNameForMobile(
                '/s/booking-calendar',
                currentPath,
              )}
              onClick={() => close()}
            >
              {t('links.book')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/tutors">
            <a
              className={getClassNameForMobile('/tutors', currentPath)}
              onClick={() => close()}
            >
              {t('service.header.tutors')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/s/materials">
            <a
              className={getClassNameForMobile('/s/materials', currentPath)}
              onClick={() => close()}
            >
              {t('service.header.materials')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/s/billing">
            <a
              className={getClassNameForMobile('/s/billing', currentPath)}
              onClick={() => close()}
            >
              {t('links.subscription')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/messages">
            <a
              className={getClassNameForMobile('/messages', currentPath)}
              onClick={() => close()}
            >
              {t('links.messenger')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/s/profile/edit">
            <a
              className={getClassNameForMobile('/s/profile/edit', currentPath)}
              onClick={() => close()}
            >
              {t('links.editProfile')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/s/sync-cal">
            <a
              className={getClassNameForMobile('/s/sync-cal', currentPath)}
              onClick={() => close()}
            >
              {t('links.syncCalendar')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={React.Fragment}>
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => {
                handleLogout();
                close();
              }}
            >
              {t('links.logout')}
            </a>
          </DisclosureButton>
        </div>
      )}
    </DisclosurePanel>
  );
};

const wrapped = withTranslation('common')(StudentHeaderMobile);

export default wrapped;
